import ModifyOrderFormController from "mercor/order_management/modify_order_form_controller";

export default class InputFinalDetailsFormController extends ModifyOrderFormController {}
